var parent = require('../../es/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/object/keys.js
// module id = 949
// module chunks = 25